import Icon from '@mui/material/Icon';
import loadable from '@loadable/component';
import { toBoolean } from 'utils/stringUtils';
import { useIntl } from 'react-intl';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import ContainerWithPreview from 'pages/entities/preview/ContainerWithPreview';
import app from 'config/app.json';
import _ from 'lodash';
import { useMemo } from 'react';

const LoadableDefaultTimeline = loadable(() => import('pages/entities/timeline/DefaultTimeline'));
const LoadableDefaultListing = loadable(() => import('pages/entities/listing/DefaultListing'));
const LoadableAdvancedListing = loadable(() => import('pages/entities/listing/AdvancedListing'));
const LoadableDefaultPreview = loadable(() => import('pages/entities/preview/DefaultPreview'));
const LoadableDashBoard = loadable(() => import('pages/dashboard'));
const LoadableEntitySearch = loadable(() => import('pages/entities/search/EntitySearch'));
const LoadableGlobalSearch = loadable(() => import('pages/globalSearch/GlobalSearch'));
const LoadableFileViewer = loadable(() => import('pages/fileViewer/FileViewerContainer'));

const useRoutes = (views, conf) => {
  const { formatMessage: msg } = useIntl();

  return useMemo(() => {
    let res = views
      .map((view, index) => {
        if (toBoolean(conf(`${view}.enabled`))) {
          const viewType = conf(`${view}.type`);

          let component = null;
          let pathSuffix = '';
          let standalone = false;
          if (viewType === 'dashboard') {
            component = <LoadableDashBoard />;
          }
          if (viewType === 'timeline') {
            component = <LoadableDefaultTimeline />;
          } else if (viewType === 'listing') {
            component = <LoadableDefaultListing />;
          } else if (viewType === 'advancedListing') {
            component = <LoadableAdvancedListing />;
          } else if (viewType === 'preview') {
            component = <LoadableDefaultPreview />;
            pathSuffix = '/:entityId';
          } else if (viewType === 'viewer') {
            component = <LoadableFileViewer />;
            pathSuffix = '/:hash';
            standalone = true;
          }
          if (component) {
            return {
              visibleInMenu: toBoolean(conf(`${view}.visibleInMenu`, true)),
              level: Number(conf(`${view}.level`, 100000 + index)),
              type: 'collapse',
              name: msg({ id: `view.${view}.shortTitle` }),
              key: view,
              icon: <Icon fontSize="small">{msg({ id: `view.${view}.icon` })}</Icon>,
              viewType,
              view: `${view}`,
              path: `${viewType}/:view${pathSuffix}`,
              standalone,
              component
            };
          }
        }
        return null;
      })
      .filter((view) => view != null);
    // Adds the search view
    res = res.concat([
      {
        type: 'collapse',
        name: 'Entity Search',
        key: 'entitySearch',
        level: Number(conf(`${app.view.search}.level`, 100000 + res.length)),
        icon: <Icon fontSize="small">manage_search_rounded</Icon>,
        viewType: 'entitySearch',
        path: 'entitySearch',
        component: conf(`search.result.detailedView`) ? (
          <ContainerWithPreview
            view={app.view.search}
            selectedStateSelector={(state) => state.search.selectedEntityId}
            resultsStateSelector={(state) => state.search.searchResults}
          >
            <LoadableEntitySearch />
          </ContainerWithPreview>
        ) : (
          <LoadableEntitySearch />
        )
      }
    ]);
    // Sort views by level
    res = _.sortBy(res, ['level']);
    // Adds views not visible in menu
    res = res.concat([
      {
        type: 'collapse',
        visibleInMenu: false,
        name: 'Global Search',
        key: 'globalSearch',
        icon: <TravelExploreRoundedIcon fontSize="small" />,
        viewType: 'globalSearch',
        path: 'globalSearch',
        component: conf(`globalSearch.result.detailedView`) ? (
          <ContainerWithPreview
            view={app.view.search}
            selectedStateSelector={(state) => state.search.selectedEntityId}
            resultsStateSelector={(state) => state.search.searchResults}
          >
            <LoadableGlobalSearch />
          </ContainerWithPreview>
        ) : (
          <LoadableGlobalSearch />
        )
      }
      // {
      //   type: 'divider',
      //   key: 'divider'
      // },
      // {
      //   type: 'title',
      //   name: 'Demo',
      //   key: 'demo',
      //   title: 'Démo'
      // },
      // {
      //   type: 'collapse',
      //   name: 'Profile',
      //   key: 'profile',
      //   icon: <Icon fontSize="small">person</Icon>,
      //   path: 'profile',
      //   component: <Profile />
      // },
      // {
      //   type: 'collapse',
      //   name: 'Sign Up',
      //   key: 'sign-up',
      //   icon: <Icon fontSize="small">assignment</Icon>,
      //   path: '/authentication/sign-up',
      //   component: <SignUp />
      // }
    ]);
    // res.splice(
    //   0,
    //   0,
    //   {
    //     type: 'collapse',
    //     name: 'Nouveau',
    //     key: 'create',
    //     path: 'create',
    //     icon: <AddIcon />
    //   },
    //   {
    //     type: 'divider',
    //     key: 'divider'
    //   }
    // );
    return res;
  }, [conf, msg, views]);
};

export default useRoutes;
